module.exports = __webpack_public_path__ + "media/images/lb/270-12f706af40ef0620d5071a417b75097e.svg";